/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import compose from 'lodash/fp/compose';
import {
  withTranslation,
  withBulkDelete,
  withDeleteConfirmation,
  withUserLayoutChoice,
  withCustomRouter,
  withCurrency,
  withMeasurementUnit,
  withOrganisation,
  withOrganisationFunction,
  withOrgFunctionAssignment,
  withReligion,
  withSchoolType,
} from 'components/hoc';
import MyDataContentTemplate from 'components/Dashboard/MyData/common/MyDataContentTemplate';
import '../style.css';
import LottieLoader from 'components/common/LottieLoader';
import axios from '../../../../../../axios';
import API from '../../../../../../utils/api';


const OrgFunctionAssignment = (props) => {
  const dispatch = useDispatch();
  const [assignedOrgFunctions, setAssignedOrgFunctions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [owner, setOwner] = useState(false);

  const navigate = useNavigate();

  const { q: organisationId } = props.routeQueries;
  const { organisationFunction, religionLocaleOptions, schoolType } = props;

  useEffect(() => {
    if (organisationId) {
      try {
        setLoading(true);
        axios
          .get(
            `${API}/organisation-function-assignment/${organisationId}/all_org_functions/`,
          )
          .then((response) => {
            const { data } = response;
            setAssignedOrgFunctions(data);
            setLoading(false);
          })
          .catch((e) => {
            setAssignedOrgFunctions([]);
            setLoading(false);
          });
      } catch (e) {
        setAssignedOrgFunctions([]);
        setLoading(false);
      }
    } else {
      setAssignedOrgFunctions([]);
      setLoading(false);
    }
  }, []);

  const searchById = (term, listItems) => {
    for (const item of listItems) {
      if (term === item?.id) {
        return item;
      }
    }
    return null;
  };
  const mapFields = () => {
    const { trObj, getOrgById } = props;
    return assignedOrgFunctions.map((orgFunction) => {
      const orgFunc = searchById(
        orgFunction?.organisation_function,
        organisationFunction,
      );
      const religionRec = searchById(orgFunction?.religion, religionLocaleOptions);
      const schoolRec = searchById(orgFunction?.school_type, schoolType);
      const org = getOrgById(orgFunction?.organisation);

     console.log("orgFunc", orgFunc)
     console.log("org", org)

      return {
        ...orgFunction,
        organisation_function: trObj(orgFunc),
        religion: trObj(religionRec),
        school_type: trObj(schoolRec),
        organisation: org?.name,
        organisationId: org?.id,
      };
    });
  };


  const tableName = 'org_function_assignment';

  const {
    tr,
    basePath,
  } = props;

  const executeOnRowClick = (orgFunc) => {};

  const goBack = () => {
    const pathArray = basePath.split('/');
    pathArray.pop();
    const pathway = `${pathArray.join('/')}/favorite-organisation`;
    navigate(pathway);
  };

  const moveToCreateOrgFunctionForm = () => {
    navigate(`/dashboard/data/base/org_func_assign/create?q=${organisationId}`);
  };

  if (loading) {
    return (
      <>
        <LottieLoader />
      </>
    );
  }

  return (
    <MyDataContentTemplate
      columns={[]}
      data={mapFields()}
      goBack
      handleGoBack={goBack}
      handleCreateForm={() => {
        moveToCreateOrgFunctionForm();
      }}
      tableName={tableName}
      hasBulkDelete={false}
    />
  );
};

export default compose(
  withTranslation,
  withBulkDelete,
  withDeleteConfirmation,
  withUserLayoutChoice,
  withCustomRouter,
  withCurrency,
  withMeasurementUnit,
  withReligion,
  withOrganisationFunction,
  withOrganisation,
  withSchoolType,
  withOrgFunctionAssignment,
)(OrgFunctionAssignment);
